import React, { Component } from "react";
import { Tabs, Card } from "antd";
import Competitors from "../../containers/DashboardSettings/Competitors";
import Keywords from "../../containers/DashboardSettings/Keywords";
import Notifications from "../../containers/DashboardSettings/Notifications";
import Location from "../../containers/DashboardSettings/Location";
import RemoveUrl from "../../containers/DashboardSettings/RemoveUrl";

const { TabPane } = Tabs;

export class DashboardSettingsTabs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeKey: this.props.selectedOption || "competitors"
    };

    this.handleTabChange = this.handleTabChange.bind(this);
  }

  handleTabChange(key) {
    this.setState({ activeKey: key });
    this.props.push(`/dashboard/settings/${key}`);
  }

  render() {
    return (
      <Card className="dashboard-settings-tabs">
        <Tabs activeKey={this.state.activeKey} onChange={this.handleTabChange}>
          <TabPane tab="Competitors" key="competitors">
            <Competitors />
          </TabPane>
          <TabPane tab="Keywords" key="keywords">
            <Keywords selectedWebsite={this.props.selectedWebsite} />
          </TabPane>
          <TabPane tab="Location" key="location">
            <Location />
          </TabPane>
          <TabPane tab="Notifications" key="notifications">
            <Notifications selectedWebsite={this.props.selectedWebsite} />
          </TabPane>
          <TabPane tab="Remove URL" key="remove-url">
            <RemoveUrl />
          </TabPane>
        </Tabs>
      </Card>
    );
  }
}

export default DashboardSettingsTabs;
